import apisauce from 'apisauce';
import invariant from 'invariant';
import jwtDecode from 'jwt-decode';

import { API_URL, DEFAULT_TIMEOUT, IS_DEV } from '../config';

const Api = {
  client: apisauce.create({
    baseURL: API_URL,
    timeout: DEFAULT_TIMEOUT
  }),

  async setup(store) {
    if (IS_DEV) {
      this.client.addMonitor(res => {
        console.log(
          `${res.config.method.toUpperCase()}(${res.status}, ${res.duration}ms) ${
            res.config.url
          } - hasToken?${!!Api.token}`
        );
        if (!res.ok) console.log('data=', res.data);
      });
    }

    Api.token = null;
    Api.user = null;
    Api.store = store;

    const { uid, token } = store.getState().user;

    if (token) {
      // TODO: Checar se o usuario está autenticado e se o token é válido...
      Api.setToken(token);
    }
  },

  setErrorHandler(fn) {
    this._errorHandler = fn;
  },

  setToken(token) {
    if (Api.token !== token) {
      if (IS_DEV) console.log(`set token: "${token}"`);
      Api.token = token;
      Api.user = token ? jwtDecode(token) : null;

      if (Api.token) Api.client.setHeader('Authorization', `Bearer ${Api.token}`);
      else Api.client.setHeader('Authorization', null);
    }
  },

  login(email, password) {
    invariant(email, 'auth/email_required');
    invariant(password, 'auth/password_required');
    return this.post('/auth/login', { email, password }).then(res => {
      Api.setToken(res.token);
      return res;
    });
  },

  logout() {
    this.setToken(null);
  },

  request(methodName, ...args) {
    return Api.client[methodName](...args)
      .then(readApiResponse)
      .catch(err => {
        if (this._errorHandler) this._errorHandler(err);
        throw err;
      });
  },

  media(url) {
    return `${API_URL}${url}`;
  },

  get: (...args) => Api.request('get', ...args),
  put: (...args) => Api.request('put', ...args),
  post: (...args) => Api.request('post', ...args),
  delete: (...args) => Api.request('delete', ...args),
  patch: (...args) => Api.request('patch', ...args)
};

export const readApiResponse = res => {
  if (res.ok) return res.data;
  return Promise.reject(res);
};

export default Api;



// WEBPACK FOOTER //
// ./src/services/Api.js